<template>
	<div>
		<b-breadcrumb>Emotes</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-form-row>
			<b-col cols="4">
				<b-form-select v-model="serviceId" :options="[ { id: 0, name: 'All' }, ...services ]" value-field="id" text-field="name"></b-form-select>
			</b-col>
			<b-col cols="3">
				<b-form-select v-model="membersOnly" :options="[ { value: '', text: 'All' }, { value: '1', text: 'Members only' }, { value: '0', text: 'Not members only' } ]"></b-form-select>
			</b-col>
			<b-col>
				<b-form-input placeholder="Search..." v-model="q" class="mb-2" />
			</b-col>
		</b-form-row>
		<b-table :items="emotes" :fields="[{ key: 'service', label: 'Service' }, { key: 'emote', label: 'Emote' }, 'shortcuts', 'flags']" small striped hover>
			<template #cell(service)="data">
				<b-avatar size="1rem" v-if="data.item.serviceIcon&&data.item.serviceIcon.url" :src="data.item.serviceIcon.url"></b-avatar> {{data.item.service_name}}
			</template>
			<template #cell(emote)="data">
				<div class="d-flex align-items-stretch">
					<img v-if="data.item.image_url" :src="data.item.image_url" alt="" class="emote-thumb mr-2">
					<div>
						{{data.item.label}}<br />
						<code>{{data.item.emote_id}}</code>
					</div>
				</div>
			</template>
			<template #cell(shortcuts)="data">
				<b-badge v-for="shortcut in data.item.shortcuts" :key="shortcut" variant="secondary" class="mr-1">{{shortcut}}</b-badge>
			</template>
			<template #cell(flags)="data">
				<b-badge v-if="data.item.is_custom" variant="info" class="mr-1">custom</b-badge>
				<b-badge v-if="data.item.is_channel" variant="primary" class="mr-1">channel</b-badge>
				<b-badge v-if="data.item.is_members" variant="success" class="mr-1">members</b-badge>
				<b-badge v-if="data.item.tier" variant="secondary">{{data.item.tier}}</b-badge>
			</template>
		</b-table>
		<pager :per-page="perPage" :skip="skip" :total="total" @change="setPage"></pager>
	</div>
</template>

<script>
import Pager from '@/components/Pager.vue';

export default {
	name: 'Emotes',
	components: {
		Pager,
	},
	data() { return {
		error: null,
		loading: 0,
		services: [],
		emotes: [],
		total: 0,
		skip: 0,
		perPage: 10,
		serviceId: null,
		membersOnly: '',
		q: undefined,
	}},
	created() {
		this.skip = parseInt(this.$route.query.skip||0)||0;
		this.perPage = parseInt(this.$route.query.perPage||10)||10;
		this.serviceId = parseInt(this.$route.query.serviceId||0)||0;
		this.membersOnly = this.$route.query.membersOnly !== undefined ? this.$route.query.membersOnly : '';
		this.loadEmotes();
		this.loadServices();
	},
	watch: {
		'$route': 'loadEmotes',
		q: 'loadEmotes',
		serviceId: function(val, oldVal) {
			if(val == this.$route.query.serviceId || val == oldVal) return;
			this.$router.push({ query: { ...this.$route.query, serviceId: val || undefined } });
		},
		membersOnly: function(val, oldVal) {
			if(val == (this.$route.query.membersOnly||'') || val == oldVal) return;
			this.$router.push({ query: { ...this.$route.query, membersOnly: val || undefined } });
		},
	},
	methods: {
		setPage($event) {
			this.skip = $event.skip;
			this.perPage = $event.perPage;
			this.$router.push({ query: { ...this.$route.query, skip: $event.skip || undefined, perPage: $event.perPage == 10 ? undefined : $event.perPage } });
		},
		loadServices() {
			this.services = [];
			this.loading++;
			this.$api.get('admin/services').then(services => {
				this.services = services.filter(s => s.capabilities.indexOf('chat') !== -1);
			}, err => this.error = err).finally(() => {
				this.loading--;
			});
		},
		loadEmotes() {
			this.loading++;
			this.error = null;
			this.$api.get('emotes', { q: this.q||'', serviceId: this.serviceId||'', membersOnly: this.membersOnly, limit: this.perPage, skip: this.skip }).then(emotes => {
				this.emotes = emotes.results;
				this.total = emotes.total;
			}).catch(err => this.error = err).finally(() => this.loading--);
		},
	},
};
</script>

<style scoped>
.emote-thumb {
	max-width: 32px;
	object-fit: contain;
}
</style>
